import { call, put, takeLatest } from 'redux-saga/effects';
import { loadingRequest, loadingSuccess } from '@stores/global/actions.js';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal.jsx';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig.js';
import {
  getAgentRequestChangeAvaService,
  getAgentRequestChangePersonalInfoService,
  getAgentRequestGenOtpForChangeAvaService,
  getAgentRequestNumAvaService,
  getAgentRequestNumNextValueService,
  getAgentRequestPaymentPlanListService,
  getAgentRequestPersonalInfoDetailsService,
  getAgentRequestPersonalInfoListService,
  getAgentRequestValidateOtpService,
  getECardAvaService,
  getECardIndividualBusinessService,
  getECardInfoService,
  getECardQrImageService,
  getRefreshOtpService,
} from '@services/myProfile.js';
import {
  setAgentRequestPaymentPlan,
  setAgentRequestPersonalInfoDetails,
  setAgentRequestPersonalInfoList,
  setECardAva,
  setECardInfo,
  setECardPersonalBusinessInfo,
  setECardQrImage,
} from '@stores/myprofile/actions.js';
import { hasValue } from '@helpers/utils/utils.js';
import {
  GET_AGENT_REQUEST_GENERATE_OTP_FOR_CHANGE_AVA,
  GET_AGENT_REQUEST_NUM_AVA,
  GET_AGENT_REQUEST_NUM_NEXT_VALUE,
  GET_AGENT_REQUEST_PAYMENT_PLAN,
  GET_AGENT_REQUEST_PERSONAL_INFO_DETAILS,
  GET_AGENT_REQUEST_PERSONAL_INFO_LIST,
  GET_AGENT_REQUEST_VALIDATE_CHANGE_AVA,
  GET_AGENT_REQUEST_VALIDATE_CHANGE_PERSONAL_INFO,
  GET_AGENT_REQUEST_VALIDATE_OTP,
  GET_E_CARD_AVATAR,
  GET_E_CARD_INFO,
  GET_E_CARD_PERSONAL_BUSINESS_INFO,
  GET_E_CARD_QR_IMAGE,
  GET_INFO_REQUEST_FORM,
  GET_REFRESH_OTP,
} from '@stores/myprofile/constants.js';

export function* getECardInfoData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getECardInfoService, payload);
    if (
      hasValue(response) &&
      ['FOUND', 'TERMINATED'].includes(response.responseCode)
    )
      yield put(
        setECardInfo({
          ...response.responsePayload,
          terminated: response.responseCode === 'TERMINATED',
        }),
      );
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getECardIndividualBusinessData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getECardIndividualBusinessService, payload);
    if (hasValue(response) && response.responseCode === 'FOUND') {
      yield put(setECardPersonalBusinessInfo(response.responsePayload));
    }
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getECardAvaData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getECardAvaService, payload);
    if (hasValue(response)) yield put(setECardAva(response));
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getECardQrImageData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getECardQrImageService, payload);
    if (hasValue(response)) yield put(setECardQrImage(response));
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentRequestChangeAvaData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getAgentRequestChangeAvaService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentRequestGenOtpForChangeAvaData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(
      getAgentRequestGenOtpForChangeAvaService,
      payload,
    );
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getRefreshOtp({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getRefreshOtpService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentRequestValidateOtpData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getAgentRequestValidateOtpService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentRequestNumAvaData({ payload, callback }) {
  try {
    console.log(payload);
    yield put(loadingRequest());
    const response = yield call(getAgentRequestNumAvaService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentRequestPersonalInfoData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(
      getAgentRequestPersonalInfoListService,
      payload,
    );
    if (hasValue(response) && response.responseCode === 'FOUND') {
      yield put(setAgentRequestPersonalInfoList(response.responsePayload));
    }
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentRequestPersonalInfoDetailData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(
      getAgentRequestPersonalInfoDetailsService,
      payload,
    );
    if (hasValue(response) && response.responseCode === 'FOUND') {
      yield put(setAgentRequestPersonalInfoDetails(response.responsePayload));
    }
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentRequestPaymentPlanData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getAgentRequestPaymentPlanListService, payload);
    if (hasValue(response) && response.responseCode === 'FOUND') {
      yield put(setAgentRequestPaymentPlan(response.responsePayload));
    }
    yield put(loadingSuccess());
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentRequestChangePersonalInfoData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(
      getAgentRequestChangePersonalInfoService,
      payload,
    );
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentRequestNumNextValueData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getAgentRequestNumNextValueService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getInfoRequestForm({ payload, callback }) {
  try {
    if (payload.personalId) {
      yield getECardInfoData({ payload: { personalId: payload.personalId } });
    }
    yield getECardIndividualBusinessData({});
    if (callback) callback();
  } catch (err) {
    console.error(err);
    if (callback) callback();
  }
}

export default function* myProfileSaga() {
  yield takeLatest(GET_E_CARD_INFO, getECardInfoData);
  yield takeLatest(
    GET_E_CARD_PERSONAL_BUSINESS_INFO,
    getECardIndividualBusinessData,
  );
  yield takeLatest(GET_E_CARD_AVATAR, getECardAvaData);
  yield takeLatest(GET_E_CARD_QR_IMAGE, getECardQrImageData);
  yield takeLatest(
    GET_AGENT_REQUEST_VALIDATE_CHANGE_AVA,
    getAgentRequestChangeAvaData,
  );
  yield takeLatest(
    GET_AGENT_REQUEST_GENERATE_OTP_FOR_CHANGE_AVA,
    getAgentRequestGenOtpForChangeAvaData,
  );
  yield takeLatest(
    GET_AGENT_REQUEST_VALIDATE_OTP,
    getAgentRequestValidateOtpData,
  );
  yield takeLatest(GET_AGENT_REQUEST_NUM_AVA, getAgentRequestNumAvaData);
  yield takeLatest(GET_REFRESH_OTP, getRefreshOtp);
  yield takeLatest(
    GET_AGENT_REQUEST_PERSONAL_INFO_LIST,
    getAgentRequestPersonalInfoData,
  );
  yield takeLatest(
    GET_AGENT_REQUEST_PAYMENT_PLAN,
    getAgentRequestPaymentPlanData,
  );
  yield takeLatest(
    GET_AGENT_REQUEST_VALIDATE_CHANGE_PERSONAL_INFO,
    getAgentRequestChangePersonalInfoData,
  );
  yield takeLatest(
    GET_AGENT_REQUEST_NUM_NEXT_VALUE,
    getAgentRequestNumNextValueData,
  );
  yield takeLatest(
    GET_AGENT_REQUEST_PERSONAL_INFO_DETAILS,
    getAgentRequestPersonalInfoDetailData,
  );
  yield takeLatest(GET_INFO_REQUEST_FORM, getInfoRequestForm);
}
